module.exports = __webpack_public_path__ + "media/images/flags/1x1/ukr-3755a9a28243848042d8cb721c33a94f.svg";